<!-- 申请意向 -->
<template>
  <div class="intention">
    <h1 class="application-title">申请意向</h1>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="intention-form">
        <div class="dis-38 label-bot-20">
          <FormItem label="1.What level of study (Masters, PhD, or both) are you applying to?"
                    prop="applyLevel">
            <Select v-model="formValidate.applyLevel"
                    placeholder="Select date"
                    style="width:480px;">
              <Option value="Master">Master</Option>
              <Option value="PhD">PhD</Option>
              <Option value="Both">Both</Option>
            </Select>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="2. What are your primary motives for pursuing graduate studies abroad?"
                    prop="studyAbroadReasons">
            <Input v-model="formValidate.studyAbroadReasons"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="3.What are your intended majors and why? (pick1-2 intended majors according to your interests)"
                    prop="priorityApplyFieldAndReasons">
            <Input v-model="formValidate.priorityApplyFieldAndReasons"
                   placeholder="Please limit your response to 250 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="4.If you intend to switch your current major to a different field of study, why do you choose to do so (if applicable)?"
                    prop="changeMajorReasons">
            <Input v-model="formValidate.changeMajorReasons"
                   placeholder="Please limit your response to 500 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="5.Please provide your detailed preference on school selection, i.e. location (any specific cities?), weather, tuition, rankings, etc."
                    prop="choosingCollegePreference">
            <Input v-model="formValidate.choosingCollegePreference"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="6. What are your near-term goals upon completion of your graduate program?"
                    prop="nearTermObjectives">
            <Input v-model="formValidate.nearTermObjectives"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="7.What are your long-term goals, as well as areas of professional/career interest?"
                    prop="longTermObjectives">
            <Input v-model="formValidate.longTermObjectives"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"></Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="8.Who (or what) inspired you to set your current goals?"
                    prop="objectivesSource">
            <Input v-model="formValidate.objectivesSource"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"> </Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label="9.What is your intended time of enrollment？"
                    prop="enrolYear">
            <Input v-model="formValidate.enrolYear"
                   placeholder="e.g. 2018"> </Input>
          </FormItem>
        </div>
        <div class="dis-38 label-bot-20">
          <FormItem label='10.What are the key experiences you have undertaken to prepare for graduate studies? Please summarize. (You may elaborate on your response in another questionnaire, "Past Experience")'
                    prop="enrolPrepared">
            <Input v-model="formValidate.enrolPrepared"
                   placeholder="Please limit your response to 100 words"
                   type="textarea"
                   :rows="6"> </Input>
          </FormItem>
        </div>
        <div class="dis-38">
          <FormItem style="margin-bottom:15px;"
                    label='11. Potential Letter of Recommendation references - who are you thinking of asking?'>
          </FormItem>
          <div class="dis-48 w720"
               v-for="(item, index) in formValidate.referrals"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeReferral(index)"></div>
            <FormItem label="Name"
                      prop="name"
                      :label-width="220">
              <Input v-model="item.referralsName"
                     placeholder="e.g. Eric Nusland"></Input>
            </FormItem>
            <FormItem label="Title"
                      prop="name"
                      :label-width="220">
              <Input v-model="item.referralsTitle"
                     placeholder="e.g. PhD Tutor"></Input>
            </FormItem>
            <FormItem label="How you know him/her"
                      prop="name"
                      :label-width="220">
              <Input v-model="item.referralsKnow"
                     placeholder="e.g. Academic Research"></Input>
            </FormItem>
            <!--<FormItem label="How well you known him/her"-->
            <!--prop="name"-->
            <!--:label-width="220">-->
            <!--<Input v-model="item.name"-->
            <!--placeholder="e.g. Close"></Input>-->
            <!--</FormItem>-->
          </div>
          <div class="application-order-add"
               @click="addReferral">添加更多 Place</div>
        </div>
        <div class="dis-38">
          <div class="label-bot-20">
            <FormItem style="margin-bottom:15px;"
                      label='12. If you are to apply for a program that is different from your undergraduate major, please list all major-related courses（optional)'>
            </FormItem>
          </div>
          <div class="dis-48 w720">
            <div class="dis-0"
                 v-for="(item, index) in formValidate.correlatedCurriculum"
                 :key="index">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeCorrelatedCurriculum(index)"></div>
              <FormItem label="Major-related courses"
                        prop="name"
                        :label-width="220">
                <Input v-model="formValidate.correlatedCurriculum[index]"
                       placeholder="e.g. Physics"></Input>
              </FormItem>
            </div>
          </div>
          <div class="application-order-add"
               @click="addCorrelatedCurriculum">添加更多 Major-related courses</div>
        </div>
        <div class="sub-btn"  v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryApplypurpose, infoModifyApplypurpose } from '@/api/info'
export default {
  name: 'application-intention',
  mixins: [isAllowEdit],
  components: {},
  data () {
    return {
      formValidate: {},
      ruleValidate: {}
    }
  },
  computed: {},
  mounted () { this.getInfo() },
  methods: {
    getInfo () {
      infoQueryApplypurpose().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)

        this.$set(this.formValidate, 'referrals', data.referrals || [{}])
        this.$set(this.formValidate, 'correlatedCurriculum', data.correlatedCurriculum || [''])
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          infoModifyApplypurpose(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-project'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    },

    addReferral () {
      this.formValidate.referrals.push({
        name: '',
        description: ''
      })
    },
    removeReferral (index) {
      this.formValidate.referrals.splice(index, 1)
    },
    addCorrelatedCurriculum () {
      this.formValidate.correlatedCurriculum.push('')
    },
    removeCorrelatedCurriculum (index) {
      this.formValidate.correlatedCurriculum.splice(index, 1)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
